// NowLine — линия текущего времени (S1): акцентная линия + точка слева.
// top — локальные минуты дня (Р1), refresh каждые NOW_LINE_REFRESH_MS,
// cleanup интервала при unmount (W2-T3).
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { MINUTES_PER_DAY, NOW_LINE_REFRESH_MS } from '@/lib/timeGridLayout';

/** Линия текущего времени в колонке дня (absolute-% от начала дня). */
export function NowLine(): JSX.Element {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), NOW_LINE_REFRESH_MS);
    return () => clearInterval(timer);
  }, []);

  const topPct = ((now.getHours() * 60 + now.getMinutes()) / MINUTES_PER_DAY) * 100;

  return (
    <Box
      data-testid="now-line"
      aria-hidden="true"
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: `${topPct}%`,
        height: 2,
        bgcolor: 'primary.main',
        zIndex: 2,
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: -3,
          top: -3,
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: 'primary.main',
        }}
      />
    </Box>
  );
}
